import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';
import { driverGroupSchema } from '../schemas/driver-group.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Retrieves Driver Groups for a specific Driver
 * @param driverId ID of Driver
 * @returns Message Object containing array of Driver Groups
 */
export function getDriversDriverGroups(this: unknown, driverId: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment.resolve(this).driverGroupsDriversIdUrl(driverId),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(fleetMessageSchema.extend({ data: z.array(driverGroupSchema) }))
  );
}
